import { EntityCategory, EventLogDataItem } from '../../../entities/EventLog/EventLog'
import { getCategoryName, translateCategoryEnum } from '../../../entities/EventLog/EventLogHelpers'
import trans from '../../../helpers/trans'

interface Category {
    key: EntityCategory;
    value: any;
}

interface CategoryItem {
    category: string;
    change: string;
}

export const convertToCategories = (log: EventLogDataItem): Category[] => Object
    .entries(log.data)
    .map(([key, value]) => ({
        key: translateCategoryEnum(key as EntityCategory),
        value,
    }))

type CategoryItemParam = Record<string, string>

export const convertToCategoryItems = (category: EntityCategory, value: CategoryItemParam): CategoryItem[] => Object
    .entries(value)
    .flatMap(([field, change]) => {
        const fieldValue = field !== '0' || category === EntityCategory.MailNotification
            ? field
            : undefined
        let categoryName = getCategoryName(category, fieldValue)

        if (! categoryName) {
            console.warn('Missing event log category name for fieldValue \'%s\'', fieldValue)
            categoryName = `${fieldValue}`
        }

        let changeValue = change

        if (typeof change === 'object' && change !== null && 'transKey' in (change as any)) {
            changeValue = trans((change as any).transKey, (change as any).transOptions)
        }

        return [{
            category: categoryName,
            change: changeValue,
        }]
    })
